import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";

const DirtyDot = () => {
  const { translate } = useLanguage();
  const label = translate("modifiedNotSaved") || "Modified — not yet saved";
  return (
    <span
      aria-label={label}
      title={label}
      className="inline-block rounded-full"
      style={{ width: 6, height: 6, backgroundColor: "var(--color-mint)" }}
    />
  );
};

export default DirtyDot;
